import { contractApi } from '../contractApi';
import { BaseRuleView } from '../types/contractTypes';
import { RuleGetRequest } from '../requests/ruleGetRequest';
import { RuleListRequest } from '../requests/ruleListRequest';
import { RulePostRequest } from '../requests/rulePostRequest';
import { RuleDeleteRequest } from '../requests/ruleDeleteRequest';

const ruleEndpoints = contractApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get rule by ID
    getRule: builder.query<BaseRuleView, RuleGetRequest>({
      query: ({ ruleId }) => ({
        url: 'rule',
        params: { ruleId },
      }),
      providesTags: (result, error, { ruleId }) => [{ type: 'Rule', id: ruleId }, 'Rule'],
    }),

    // Get all rules by contract ID
    getRulesByContractId: builder.query<BaseRuleView[], RuleListRequest>({
      query: ({ contractId }) => ({
        url: 'RulesList',
        method: 'GET',
        params: { contractId },
      }),
      providesTags: (result, error, { contractId }) => [
        { type: 'RuleList', id: contractId },
        'Rule',
      ],
    }),

    // Upsert rule (create or update)
    upsertRule: builder.mutation<{ id: string }, RulePostRequest>({
      query: (body) => ({
        url: 'Rule',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, body) => [
        ...(body.ruleId && body.ruleId !== '0'
          ? [{ type: 'Rule' as const, id: body.ruleId }]
          : []),
        { type: 'RuleList', id: body.contractId },
        'Rule',
        'RuleList',
      ],
    }),

    // Delete rule
    deleteRule: builder.mutation<BaseRuleView, RuleDeleteRequest>({
      query: (body) => ({
        url: 'RuleDelete',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'Rule', id: body.ruleId },
        'Rule',
        'RuleList',
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRuleQuery,
  useGetRulesByContractIdQuery,
  useUpsertRuleMutation,
  useDeleteRuleMutation,
} = ruleEndpoints;
